import Vue from "vue";
import authErrorMixin from "@/mixins/authErrorMixin";
export default Vue.extend({
    mixins: [authErrorMixin]
});
